import React from "react";
import { Tooltip } from "react-tooltip";

import PillSwitch from "../../components/PillSwitch/PillSwitch";
import PointsPredictionTeamsTable from "./PointsPredictionTeamsTable";
import { TEAMS_TOOLTIP_ID } from "./SortHeader";
import { useMediaQuery } from "../../useMediaQuery";

// Views of the teams card. On wide screens team strength is always shown, next to the upcoming
// games (expected goals or clean sheet chances); on narrow screens it's one of three views.
const GAMES_VIEWS = [
    { key: "goals", label: "Goals" },
    { key: "cs", label: "CS" },
];
const NARROW_VIEWS = [...GAMES_VIEWS, { key: "strength", label: "Team Strength" }];

// Room for the team strength and upcoming games sections side by side
export const WIDE_TEAMS_QUERY = "(min-width: 768px)";

// The Teams sub-page's card. `rows` are the teams in the current sort order (see
// buildTeamRows / sortTeamRows); `view` is "goals", "cs" or "strength".
const PointsPredictionTeamsCard = ({ rows, gameweeks, view, onViewChange, sort, onSort }) => {
    const wide = useMediaQuery(WIDE_TEAMS_QUERY);
    // Wide: strength is always there, so a "strength" view (picked on a narrow screen) shows goals
    const gamesMetric = view === "strength" ? "goals" : view;
    const tableProps = { rows, gameweeks, metric: gamesMetric, sort, onSort };

    const title = wide ? "Team predictions" : (view === "strength" ? "Team strength" : "Upcoming games");
    const switchControl = wide
        ? <PillSwitch options={GAMES_VIEWS} value={gamesMetric} onChange={onViewChange}
                      label="Value shown per game" className="teams-title-control"/>
        : <PillSwitch options={NARROW_VIEWS} value={view} onChange={onViewChange}
                      label="Teams view" className="teams-title-control"/>;

    return (
        <div className={`teams-card-block ${wide ? "teams-card-wide" : ""}`}>
            <div className={"title-container teams-title-row noSelect"}>
                <div className={"font-totw-title"}>{title}</div>
                {switchControl}
            </div>
            <div className={"player-list-container noSelect"}>
                {wide ? (
                    // One card, two sections side by side with the same rows: team strength, then
                    // the upcoming games (which read their team names off the strength section)
                    <div className="teams-sections">
                        <div className="teams-section teams-section-strength">
                            <PointsPredictionTeamsTable {...tableProps} showStrength showGames={false}/>
                        </div>
                        <div className="teams-section teams-section-games">
                            <PointsPredictionTeamsTable {...tableProps} showStrength={false} showGames showTeam={false}/>
                        </div>
                    </div>
                ) : (
                    <PointsPredictionTeamsTable {...tableProps}
                                                showStrength={view === "strength"} showGames={view !== "strength"}/>
                )}
            </div>
            <Tooltip id={TEAMS_TOOLTIP_ID} className="my-tooltip"/>
        </div>
    );
};

export default PointsPredictionTeamsCard;
